﻿jQuery.fn.extend({
    findByValue: function (tagName, valToFind) {
        return $(this.find(tagName).filter(function (i, e) {
            return e.value == valToFind;
        }));
    }
});
jQuery.fn.extend({
    setHref: function (url) {
        if (url && !url.toLowerCase().startsWith("javascript:")) {
            $(this).attr('href', url);
        }
    }
});

var sizeTool = {
    getSize: function () {
        if (window.innerWidth < 768) {
            return "xs";
        }
        else if (window.innerWidth >= 768 && window.innerWidth <= 992) {
            return "sm";
        }
        else if (window.innerWidth > 992 && window.innerWidth <= 1200) {
            return "md";
        }
        else {
            return "lg";
        }
    },
    isAtLeast: function (size) {
        var curSize = sizeTool.getSize();
        switch (size.toLowerCase()) {
            case "xs":
                return true;
            case "sm":
                return curSize === "sm" || curSize === "md" || curSize === "lg";
            case "md":
                return curSize === "md" || curSize === "lg";
            case "lg":
                return curSize === "lg";
            default:
                return false;
        }
    }
};

var globalVariables = { unloaded: false };
$(window).on('beforeunload', function () {
    globalVariables.unloaded = true;
});

var handlebarsHelper = {
    templates: [],
    getTemplates: function (templateFile, templateName) {
        var dfd = $.Deferred();
        if (templateName && handlebarsHelper.templates[templateName])
            return dfd.resolve();
        if (!templateName)
            templateName = 'default';
        var _headers = { "RequestVerificationToken": $("#RequestVerificationToken").val() };
        var url = "/handlers" + (CurrentUserId ? "" : "anon") + "/GetHtml.ashx";
        $.ajax({
            url: url + "?htmlPath=" + encodeURIComponent(templateFile) + "&amp;lang=" + CurrentThreadLanguageUI + "&amp;ts=" + versionTS,
            headers: _headers,
            success: function (data) {
                handlebarsHelper.templates[templateName] = $(data);
                dfd.resolve();
            },
            cache: true,
            async: false
        });
        return dfd.promise();
    },
    getTemplate: function (templateId, templateName) {
        if (!templateName)
            templateName = 'default';
        var source = handlebarsHelper.templates[templateName].find("#" + templateId).html();
        return source;
    },
    compileTemplate: function (templateId, templateName) {
        var source = handlebarsHelper.getTemplate(templateId, templateName);
        var template = Handlebars.compile(source);
        return template;
    },
    configHandlebars: function (cultureInfo) {
        if (cultureInfo === undefined)
            cultureInfo = CultureInfo;
        Handlebars.registerHelper("formatDate", function (datetime) {
            if (datetime && datetime.length > 3) {
                return moment(datetime).format(cultureInfo.DateFormat);
            }
            else {
                return datetime;
            }
        });
        Handlebars.registerHelper("formatDateTime", function (datetime, showTime) {
            if (datetime && datetime.length > 3) {
                var d = moment(datetime);
                if (d.year() == 1)
                    return '';
                else if (d.hours() == 0 && d.minutes() == 0 && showTime!=true)
                    return d.format(cultureInfo.DateFormat);
                else
                    return d.format(cultureInfo.DateTimeFormat);
            }
            else {
                return datetime;
            }
        });
        Handlebars.registerHelper("formatDecimal", function (n, decimals) {
            return numericConverter.numericToString(n, decimals);
        });
        Handlebars.registerHelper('select', function (value, options) {
            var $el = $('<select />').html(options.fn(this));
            $el.find('[value="' + value + '"]').attr({ 'selected': 'selected' });
            return $el.html();
        });
        Handlebars.registerHelper("switch", function (value, options) {
            this._switch_value_ = value;
            this._switch_default_ = true;
            var html = options.fn(this); // Process the body of the switch block
            delete this._switch_value_;
            return html;
        });
        Handlebars.registerHelper("case", function (value, options) {
            if (value == this._switch_value_) {
                this._switch_default_ = false;
                return options.fn(this);
            }
        });
        Handlebars.registerHelper("default", function (options) {
            return this._switch_default_ === true
                ? options.fn(this)
                : "";
        });
        Handlebars.registerHelper('for', function (from, to, incr, block) {
            var accum = '';
            for (var i = from; i <= to; i += incr)
                accum += block.fn(i);
            return accum;
        });
        Handlebars.registerHelper('times', function (n, block) {
            var accum = '';
            for (var i = 0; i < n; ++i)
                accum += block.fn(i);
            return accum;
        });
        Handlebars.registerHelper('formatString', function () {
            var formatted = "";
            var i = 0;
            if (arguments.length > 0) {
                formatted = arguments[0];
                for (arg = 1; arg < arguments.length - 1; arg++)//last argument is helper name
                {
                    var re = new RegExp("\\{" + (arg - 1) + "\\}", "gi");
                    formatted = formatted.replace(re, arguments[arg]);
                }
            }
            return formatted;
        });
        Handlebars.registerHelper("json", function (value) {
            return JSON.stringify(value);
        });
        Handlebars.registerHelper("displayList", function (list, elemName, htmlTag) {
            var res = "";
            $.each(list, function () {
                res += "<" + htmlTag + ">" + this[elemName] + "</" + htmlTag + ">";
            });
            return res;
        });
        Handlebars.registerHelper('eq', function(arg1, arg2, options) {
            return (arg1 == arg2) ? options.fn(this) : options.inverse(this);
        });
        Handlebars.registerHelper('neq', function (arg1, arg2, options) {
            return (arg1 != arg2) ? options.fn(this) : options.inverse(this);
        });
        Handlebars.registerHelper('ifCond', function (v1, operator, v2, options) {

            switch (operator) {
                case '==':
                    return (v1 == v2) ? options.fn(this) : options.inverse(this);
                case '===':
                    return (v1 === v2) ? options.fn(this) : options.inverse(this);
                case '!=':
                    return (v1 != v2) ? options.fn(this) : options.inverse(this);
                case '!==':
                    return (v1 !== v2) ? options.fn(this) : options.inverse(this);
                case '<':
                    return (v1 < v2) ? options.fn(this) : options.inverse(this);
                case '<=':
                    return (v1 <= v2) ? options.fn(this) : options.inverse(this);
                case '>':
                    return (v1 > v2) ? options.fn(this) : options.inverse(this);
                case '>=':
                    return (v1 >= v2) ? options.fn(this) : options.inverse(this);
                case '&&':
                    return (v1 && v2) ? options.fn(this) : options.inverse(this);
                case '||':
                    return (v1 || v2) ? options.fn(this) : options.inverse(this);
                default:
                    return options.inverse(this);
            }
        });
        Handlebars.registerHelper('ifglobal', function (key, block) {
            if (eval(key))
                return block.fn(this);
            else
                return block.inverse(this);
        });
        Handlebars.registerHelper('unlessglobal', function (key, block) {
            if (!eval(key))
                return block.fn(this);
            else
                return block.inverse(this);
        });
        Handlebars.registerHelper('isNotLastListItem', function (currId, listSize, options) {
            return (currId != listSize - 1) ? options.fn(this) : options.inverse(this);
        });
        Handlebars.registerHelper('ifEquals', function (arg1, arg2, options) {
            return (arg1 == arg2) ? options.fn(this) : options.inverse(this);
        });
        
        Handlebars.registerHelper('ifHasValue', function (arg1, options) {
            return (arg1 != null && arg1 !== '' && arg1 !== 'undefined' && arg1 !== 'null') ? options.fn(this) : options.inverse(this);
        });
        Handlebars.registerHelper('any', function () {
            for (var i = 0; i < arguments.length - 1; i++) {
                if (arguments[i]) return true;
            }
            return false;
        });
    }
};
var preloader = {
    preloaderHTML: '<div class="preloaderwrapper z-index-5-b"><div class="preloader"></div></div>',
    templatePreloader: null,

    addPreloader: function ($container, preloaderClass, coverContainer) {
        if (!preloader.templatePreloader)
            preloader.templatePreloader = Handlebars.compile(preloader.preloaderHTML);
        var $preloader = $(preloader.templatePreloader());
        $preloader.addClass(preloaderClass);
        if ($container[0] === window) {
            $preloader.addClass("window");
            $("body").append($preloader);
        }
        else
            $container.append($preloader);
        if (coverContainer) {
            $preloader.addClass("cover center");
            $preloader.children().css("margin-top", $container.height() / 2 - $preloader.children().height() / 2);
            $container.addClass("relcont");
        }
        else if ($container.height() >= $preloader.height()) {
            $preloader.addClass("center");
            $preloader.children().css("margin-top", $container.height() / 2 - $preloader.children().height() / 2);
            $container.addClass("relcont");
        }
    },
    addPreloaderDoc: function () {
        preloader.addPreloader($(window), "documentpreloader", true);
        $("body").trigger("preloaderdoc:added");
    },
    removePreloader: function ($container, preloaderClass) {
        if ($container[0] === window)
            $("body").find(".preloaderwrapper." + preloaderClass).remove();
        else
            $container.find(".preloaderwrapper." + preloaderClass).remove();
    },
    removePreloaderDoc: function () {
        preloader.removePreloader($(window), "documentpreloader");
        $("body").trigger("preloaderdoc:removed");
    }
};

var modalWindow = {
    //deprecated - don't use it
    showModal: function (title, message, id, buttons, size, afterCreate) {
        return modalWindow.showModalWnd({ "title": title, "message": message, "id": id, "buttons": buttons, "size": size, "afterCreate": afterCreate });
    },
    //{ "title": title, "messageHeader": messageHeader, "message": message, "messageInfo": messageInfo, "id": id, "buttons": buttons, "size": size, "afterCreate": afterCreate, "closeTitle":closeTitle, "afterClose":afterClose
    //  , "hideCloseBtn": hideCloseBtn, fullHeight: true, afterShow: afterShow }
    showModalWnd: function (config) {//size: sm, lg, fs(full screen)
        modalWindow.rememberActiveElement(); 
        handlebarsHelper.getTemplates("/templates/mcommon.htmltemplate", "mcommon");
        var modalTemp = handlebarsHelper.compileTemplate("alert-template", "mcommon");
        //throw "This is an unique string of characters, heck yeah!";
        if (!config.closeTitle)
            config.closeTitle = resourcesStore.get("Cancel");

        // random config id if not specified because it's needed for focusAndLock
        if (!config.id || config.id === "") {
            config.id = "modal" + Math.random().toString(36).substring(2, 15);
        }

        var $modal = $(modalTemp(config));

        $modal.on("shown.bs.modal", function () {
            var maxModalHeight;
            if (IsMobileDevice())
                maxModalHeight = $(window).height() - 20;
            else
                maxModalHeight = $(window).height() - 60;//60 margin top/bottom;
            var bodyHeight = maxModalHeight -
                ($modal.find(".modal-header").outerHeight(true) + $modal.find(".modal-footer").outerHeight(true));
            $modal.find(".modal-body").css({ "max-height": (bodyHeight + "px") });
            if (config.fullHeight == true)
                $(".modal-body").height(bodyHeight);
            else
                $(".modal-body").height("auto");

            if (config.minHeight) {
                $("div.modal-content").css("min-height", config.minHeight);
            }

            if (config.minWidth) {
                $("div.modal-content").css("min-width", config.minWidth);
            }

            if (typeof config.afterShow === "function") {
                config.afterShow($modal);
            }

            if (config.modalClass) {
                $modal.addClass(config.modalClass);
            }
            
            // Apply WCAG focus management
            modalWindow.focusAndLock(config.id);
        });

        $modal.on("resize", function () {
            // Find the one div that is resizeable
            let modalHeight = $modal.find("div.modal-content.ui-draggable.ui-resizable").outerHeight(true);
            let headerHeight = $modal.find(".modal-header").outerHeight(true);
            let footerHeight = $modal.find(".modal-footer").outerHeight(true);
            let bodyHeight = modalHeight - headerHeight - footerHeight;
            let modalBody = $modal.find(".modal-body");
            modalBody.css({ "max-height": (`${bodyHeight}px`) });
        });

        $("body").append($modal);
        $.each(config.buttons, function () {
			//todo fix
            var btn = this;
            $modal.find("#" + this.id).click(function () {
                var res = btn.action($modal);
                if (typeof res !== "undefined" && typeof res.then === "function")
                    res.then(function (val) {
                        if (typeof val === "undefined" || val)
                            $modal.modal('hide');
                    });
                else if (typeof res === "undefined" || res)
                    $modal.modal('hide');
            });
            if (btn.default) {
                $modal.find("input").on("keypress", function (event) {
                    if (event.keyCode == 10 || event.keyCode == 13) {
                        event.preventDefault();
                        $modal.find("#" + btn.id).trigger("click");
                    }
                });
            }
        });
        if (typeof config.afterCreate === "function") {
            config.afterCreate($modal);
        }
        //only close btn
        if (typeof config.afterClose === "function") {
            $modal.find("#closebtn").on("click", config.afterClose);
        }
        //detect close event
        if (typeof config.afterModalClose === "function") {
            $modal.on("hidden.bs.modal", config.afterModalClose);
        }
        
        // Add a hidden.bs.modal handler to unlock focus trap when modal is closed
        $modal.on("hidden.bs.modal", function() {
            modalWindow.unlock(config.id);
        });
        
        $modal.modal({ backdrop: 'static' });
        $(document.body).addClass('prevent-scroll');
        $modal.on('hidden.bs.modal', function () {
            $modal.remove();
            if ($('body > .modal').length > 0) {
                $(document.body).addClass('modal-open');
            } else {
                $(document.body).removeClass('prevent-scroll');
            }
        });
        $modal.find('.modal-content').draggable({
            handle: ".modal-header"
        }).resizable();
        return $modal;
    },
    showFullScreen: function (body, id, cssclass, closeFunc) {
        handlebarsHelper.getTemplates("/templates/mcommon.htmltemplate", "mcommon");
        var fullScreenTemp = handlebarsHelper.compileTemplate("fullscreen-template", "mcommon");
        var $full = $(fullScreenTemp({ "body": body, "id": id, "cssclass": cssclass }));
        $("body").append($full);
		$("body > form").addClass("hidden");
        if (typeof closeFunc === "function") {
            $("#close" + id).removeAttr("onclick").on("click", function () { closeFunc(); modalWindow.closeFullScreen(id); });
        }
    },
    closeFullScreen: function (id) {
        if (location.hash.indexOf(";fs") != -1)
            location.hash = location.hash.replace(";fs", "");

        $("#" + id).remove();
        $("#close" + id).remove();
		$("body > form").removeClass("hidden");
    },
    confirm: function (confirmTitle, confirmText, whenOK) {
        var buttons = [{
            name: resourcesStore.get("OK"), id: "okbtn", style: "btn-primary", action: function () {
                whenOK();
            }
        }];
        modalWindow.showModalWnd({ title: confirmTitle, message: confirmText, id: "confirmdialog", buttons: buttons, closeTitle: resourcesStore.get("Cancel") });
    },
    focusAndLock: function (id) {
        var $modal = $("#" + id);
        if (!$modal.length) return;

        $modal.attr("tabindex", "-1");
        var focusableElems = $modal
            .find("a[href], button, input, textarea, select, [tabindex]:not([tabindex='-1'])")
            .filter(":visible");
        if (!focusableElems.length) return;

        var firstElem = focusableElems[0];
        var lastElem = focusableElems[focusableElems.length - 1];

        $modal.data("keydownHandler", function (e) {
            if (e.key === "Tab" || e.keyCode === 9) {
                if (e.shiftKey && document.activeElement === firstElem) {
                    e.preventDefault();
                    lastElem.focus();
                } else if (!e.shiftKey && document.activeElement === lastElem) {
                    e.preventDefault();
                    firstElem.focus();
                }
            }
        });
        $modal.on("keydown.modalFocusTrap", $modal.data("keydownHandler"));

        // Only for focusing, skip elements with .close class
        var firstNonCloseElem = focusableElems.filter(function () {
            return !$(this).hasClass("close");
        })[0];
        if (firstNonCloseElem) {
            $(firstNonCloseElem).focus();
        } else {
            $(firstElem).focus();
        }
    },
    unlock: function (id) {
        var $modal = $("#" + id);
        if (!$modal.length) return;

        // Remove focus trap
        $modal.off("keydown.modalFocusTrap");
        $modal.removeData("keydownHandler");
        $modal.removeAttr("tabindex");

        modalWindow.returnFocus();
    },
    rememberActiveElement: function () {
        var activeElement = document.activeElement;
        // if activeElement is not body
        if (activeElement && activeElement.tagName.toLowerCase() !== "body") {
            $("body").data("previouslyFocusedElement", activeElement);
            // get list of parents of focused element
            var parents = $(document.activeElement).parentsUntil("body");
            $("body").data("parentsOfFocusedElement", parents);
        }
    },
    returnFocus: function () {
        var previouslyFocusedElement = $("body").data("previouslyFocusedElement");
        var parents = $("body").data("parentsOfFocusedElement");
        // previouslyFocusedElement not undefined and element exists, focus on it
        if (previouslyFocusedElement != null && previouslyFocusedElement.length > 0) {
            previouslyFocusedElement.focus();
        } else if (parents != null) { // go through parents and find focusable element
            var parentsArray = parents.get();
            while (parentsArray.length > 0) {
                var $currentParent = $(parentsArray.shift());
                if ($currentParent.is(':focusable') && $currentParent.is(':visible')) {
                    $currentParent.focus();
                    break;
                } else {
                    var $focusableChildren = $currentParent.find(':focusable:visible');

                    // Check if any focusable children were found
                    if ($focusableChildren.length > 0) {
                        // Focus on the first one in the collection
                        $focusableChildren.first().focus();
                        break;
                    }
                }
            }
        }

        $("body").removeData("previouslyFocusedElement");
        $("body").removeData("parentsOfFocusedElement");
    }
};

var resourcesStore = {
    resourcesCache: null,
    organizationUrl: null,
    resourcesCacheKey: function () {
        return 'amoditresources' + CurrentThreadLanguageUI;
    },
    createObj(arr) {
        return { "ver": BuildVersion, "arr": arr };
    },
    initCache: function () {
        if (resourcesStore.resourcesCache === null) {
            var stored = mStorage.getItem(resourcesStore.resourcesCacheKey(), false);
            if (stored) {
                resourcesStore.resourcesCache = JSON.parse(stored);
            }
            else {
                resourcesStore.resourcesCache = resourcesStore.createObj([]);
            }
        }
    },
    //namespace: example AMODClasses
    get: function (name, namespace) {
        resourcesStore.initCache();
        var res = resourcesStore.resourcesCache.arr.filter(function (r) { return r.Name === name });

        if (res.length === 0) {
            var tmp = this;
            var absUrl = "/api/utils/resource?parameters=" + JSON.stringify([name]);
            if (namespace != null && namespace != "")
                absUrl = absUrl + "&resNamespace=" + namespace;
            $.ajax({
                type: "get",
                url: absUrl,
                dataType: "json",
                async: false
            })
                .done(function (responseJson) {
                    if (resourcesStore.resourcesCache === null)
                        resourcesStore.resourcesCache = resourcesStore.createObj(responseJson);
                    else
                        resourcesStore.resourcesCache.arr = resourcesStore.resourcesCache.arr.concat(responseJson);
                    mStorage.setItem(resourcesStore.resourcesCacheKey(), JSON.stringify(resourcesStore.resourcesCache), false);
                });
            res = resourcesStore.resourcesCache.arr.filter(function (r) { return r.Name === name });
        }
        if (res.length > 0)
            return res[0].Value;
        else
            return "resource not found";
    },
    initialize: function () {
        resourcesStore.initCache();
        if (resourcesStore.resourcesCache.arr.length == 0) {
            // When user is not signed in, CurrenUserLanguage variable will be null
            // therefore we have to use CurrentThreadLanguageUI variable, which will be set upfront 
            // based on browser language
            let userLang = CurrentUserLanguage ? CurrentUserLanguage : CurrentThreadLanguageUI;

            $.ajax({
                type: "get",
                url: "/api/utils/initresources?lang=" + userLang,
                dataType: "json",
                async: false
            }).done(function (responseJson) {
                resourcesStore.resourcesCache.arr = resourcesStore.resourcesCache.arr.concat(responseJson);
                mStorage.setItem(resourcesStore.resourcesCacheKey(), JSON.stringify(resourcesStore.resourcesCache), false);
            });
        }
    }
};
$(function () {
    resourcesStore.initialize();
});
var toasts = {
    showToast: function (options) {
        toastr.options = { "positionClass": "toast-bottom-right" };
        var func;
        switch (options.type) {
            case "success":
                func = toastr.success;
                break;
            case "info":
                func = toastr.info;
                break;
            case "warning":
                func = toastr.warning;
                break;
            case "error":
                func = toastr.error;
                break;
        }
        if (func) {
            if (options.title) {
                func(options.message, options.title);
            }
            else {
                func(options.message);
            }
        }
    },
    //user must close it
    showPermanentToast: function (options) {
        toastr.options = {
            "positionClass": "toast-bottom-right",
            "timeOut": 0,
            "extendedTimeOut": 0,
            "closeButton": true
        };
        var func;
        switch (options.type) {
            case "success":
                func = toastr.success;
                break;
            case "info":
                func = toastr.info;
                break;
            case "warning":
                func = toastr.warning;
                break;
            case "error":
                func = toastr.error;
                break;
        }
        if (func) {
            if (options.title) {
                func(options.message, options.title);
            }
            else {
                func(options.message);
            }
        }
    }
};
var mStorage = {
    localStorageEnabled: null,
    sessionStorageEnabled: null,
    init: function () {
        if (mStorage.localStorageEnabled == null || mStorage.sessionStorageEnabled == null) {
            try {
                localStorage.getItem("test");
                mStorage.localStorageEnabled = true;
            }
            catch (e) {
                mStorage.localStorageEnabled = false;
            }
            try {
                sessionStorage.getItem("test");
                mStorage.sessionStorageEnabled = true;
            }
            catch (e) {
                mStorage.sessionStorageEnabled = false;
            }
        }
    },
    getItem: function (key, useSessionStorage) {
        mStorage.init();
        if (mStorage.localStorageEnabled && !useSessionStorage) {
            return localStorage.getItem(key);
        }
        else if (mStorage.sessionStorageEnabled) {
            return sessionStorage.getItem(key);
        }
        else {
            return null;
        }
    },
    setItem: function (key, val, useSessionStorage) {
        mStorage.init();
        if (mStorage.localStorageEnabled && !useSessionStorage) {
            localStorage.setItem(key, val);
        }
        else if (mStorage.sessionStorageEnabled) {
            sessionStorage.setItem(key, val);
        }
    },
    removeItem: function (key, useSessionStorage) {
        mStorage.init();
        if (mStorage.localStorageEnabled && !useSessionStorage) {
            localStorage.removeItem(key);
        }
        else if (mStorage.sessionStorageEnabled) {
            sessionStorage.removeItem(key);
        }
    },
}
var mAjax = {
    reqQueue: [],
    processingReqQueue: false,
    processReqQueue: function () {
        if (!mAjax.processingReqQueue && mAjax.reqQueue.length > 0) {
            mAjax.processingReqQueue = true;
            var queueReq = mAjax.reqQueue.shift();
            if (queueReq) {
                mAjax.afxAjax(queueReq.request).done(function (response) {
                    queueReq.dfd.resolve(response);
                })
                    .fail(function (response) {
                        queueReq.dfd.reject(response);
                    })
                    .always(function () {
                        mAjax.processingReqQueue = false;
                        mAjax.processReqQueue();
                    });
            }
            else
                mAjax.processingReqQueue = false;
        }
    },
    afxAjaxQueue: function (request) {
        var dfd = $.Deferred();
        var queueReq = { "request": request, "dfd": dfd };
        mAjax.reqQueue.push(queueReq);
        mAjax.processReqQueue();
        return dfd;
    },
    afxAjax: function (request) {
        return mAjax.afxAjaxExtended(request, false, false);
    },
    afxAjaxExtended: function (request, hideHeadersInLogs, hideParametersInLogs) {
        var dfd = $.Deferred();
        var isWindowsIdentity = typeof windowsIdentity !== 'undefined' && windowsIdentity;
        var isAnonymous = typeof anonymousPage !== 'undefined' && anonymousPage;
        if (!isWindowsIdentity && !isAnonymous && typeof getCookie === "function" && getCookie("AMODWebAppAuthCookieTime") === null)
            topMenuWorkerApi.getLoginPage().done(function (response) { window.location.href = response.d; });

        var $csrf = $("#RequestVerificationToken");
        if ($csrf.length == 0 && window.parent != undefined && window.parent != null && window.parent.jQuery)
            $csrf =  window.parent.$("#RequestVerificationToken");
        var headers = $.extend(true, {}, request.headers);
        if ($csrf.length > 0)
            headers.RequestVerificationToken = $csrf.val();
        if (mStorage.getItem("caseprofiler"))
            headers.CaseProfiler = 1;
        if (typeof mCase != "undefined" && !jQuery.isEmptyObject(mCase.geolocation)) 
            headers = $.extend({}, headers, mCase.geolocation);
        if (typeof mCaseMasterKeys !== 'undefined')
            mCaseMasterKeys.setRequestHeader(headers);
        request.headers = headers;
        var orgName = typeof CurrentOrganization !== 'undefined' && CurrentOrganization ? CurrentOrganization: 'amod';
        request.url = request.url + (request.url.indexOf("?") > 0 ? "&" : "?") + "_o=" + orgName;
        var _request = request;
        //var res = $.ajax(request);
        var failRegistered = request.failRegistered || false;
        var prevFail = dfd.fail;
        dfd.fail = function (arg) {
            //if (arg && arg.length > 0 || dfd.then && dfd.then.arguments && dfd.then.arguments.length > 1) {
            //    failRegistered = true;
            //}
            prevFail(arg);
            return dfd;
        };
        if (typeof request.data === "string" && request.contentType === undefined)
            request.contentType = "text/plain";
        $.ajax(request).then(function (response) {
            if (response && response.profiler)
                caseProfiler.show(response.profiler);
            dfd.resolve(response);
        }, function (response) {
                try {
                    if (response && response.status != 400 && response.status != 403 && response.status != 0) {
                        var requestToLog = _request;
                        if (hideHeadersInLogs) {
                            requestToLog.url = request.url.split("?")[0];
                            delete requestToLog["headers"];
                        }
                        SystemLogEventExtended(1, "ajax error", "request: " + JSON.stringify(requestToLog) + "; response: " + JSON.stringify(response), hideParametersInLogs);
                    }
                }
                catch (e) { }
                if (!failRegistered) {
                    try {
                        preloader.removePreloaderDoc();
                        if (request.showToastOnError !== false) {
                            if (response.status != 0 || !globalVariables.unloaded) {
                                toasts.showToast({ 'type': 'error', 'message': resourcesStore.get('ErrorOccured') });
                            }
                        }
                    }
                    catch (e) { }
                }
            dfd.reject(response);
        });
        return dfd;
    },
    failResponse: function (response) {
        var toastText, toastType;
        if (response != null && response.responseJSON != null && (response.responseJSON.Message || response.responseJSON.ExceptionMessage)) {
            toastText = response.responseJSON.ExceptionMessage ? response.responseJSON.ExceptionMessage : response.responseJSON.Message;
        }
        else {
            toastText = resourcesStore.get('GenericErrorText');
        }
        if (response && response.status >= 400 && response.status < 500) {
            toastType = 'warning';
        }
        else
            toastType = 'error';
        toasts.showToast({ 'type': toastType, 'message': toastText });
    },
    errorCounter: {},
    afxAjaxAddRequestVerificationToken: function (xhr) {
        var $csrf = $("#RequestVerificationToken");
        if ($csrf.length > 0)
            xhr.setRequestHeader('RequestVerificationToken', $csrf.val());
    },
    afxAjaxRepeat: function (request, dfdAjx) {
        if (!request.timeout)
            request.timeout = 3000;
        if (!dfdAjx) {
            dfdAjx = $.Deferred();
            dfdAjx.count = 1;
        }
        request.showToastOnError = false;
        mAjax.afxAjax(request).then(function (response) {
            dfdAjx.resolve(response);
            return;
        }, function (response) {
            if (response.status == 0 && dfdAjx.count <= 3) {
                if (request.timeout)
                    request.timeout += dfdAjx.count * 1000;
                dfdAjx.count++;
                mAjax.afxAjaxRepeat(request, dfdAjx);
            }
            else {
                dfdAjx.reject(response);
                return;
            }
        });
        return dfdAjx;
    },
    afxBeacon: function (uri) {
        if (typeof navigator.sendBeacon === "function") {
            var dfd = $.Deferred();
            navigator.sendBeacon(uri);
            dfd.resolve();
            return dfd;
        }
        else {
            return mAjax.afxAjax({
                type: "post",
                cache: false,
                url: uri
            });
        }
    }
};

(function ($) {
    var createUserSelector = function ($div, options) {
        handlebarsHelper.getTemplates("/templates/mcommon.htmltemplate", "mcommon");
        var _this = this;
        $div.addClass("userselectordiv");
        _this.$div = $div;
        _this.$ul = $("<ul class='userselector'></ul>");
        if (options.Boxed)
            _this.$ul.addClass("boxed");
        if (!options.Placeholder)
            options.Placeholder = resourcesStore.get('AddNewUser2');
        _this.options = options;
        var addUserTempl = handlebarsHelper.compileTemplate("userselector-adduser-template", "mcommon");
        _this.userTemp = handlebarsHelper.compileTemplate("userselector-user-template", "mcommon");

        var $addUser = $(addUserTempl(
            Object.assign({}, options, { ShowExpandUserArea: options.MultiSelect && !options.HideExpandUserArea })
        ));
        if (options.Boxed)
            $addUser.css("clear", "both");
        this.$input = $addUser.find("input.userselect");
        var dropDown = false;
        if (typeof options.dropDown !== "undefined")
            dropDown = options.dropDown;
        var config = {};
        if (options.GroupId) {
            dropDown = true;
            config.Type = "Group";
            if (options.GroupId.constructor === Array)
                config.Values = options.GroupId;
            else
                config.Values = [options.GroupId];
        }
        else if (!options.AllUserAllowed && (options.UserType == 'contributor' || options.UserType == 'cc')) {
            config.Type = "Status";
            config.Values = [options.PstId];
        }
        if (options.AllowGroups)
            config.Groups = true;
        if (options.AllowGroupsWithoutUser)
            config.AllowGroupsWithoutUser = true;
        if (options.ExternalUsers)
            config.ExternalUsers = true;
		if(options.dropdownLeftOffset){
			config.dropdownLeftOffset = options.dropdownLeftOffset;
		}
		if(options.dropdownWidth){
			config.dropdownWidth = options.dropdownWidth;
		}
        var hideEmpty = true;
        if (options.hideEmpty != null)
            hideEmpty = options.hideEmpty;

        var getItemsFunc;
        if (options.getItemsFunc)
            getItemsFunc = options.getItemsFunc;
        else
            getItemsFunc = mAutocomplete.getUsers;
        this.$autocomplete = this.$input.formAutocomplete({
            "getItemsFunc": getItemsFunc, "dropdown": dropDown, "fieldConfig": config, "hideEmpty": hideEmpty, afterSelect: function (pos, $input) {
                _this.$div.trigger("userAdded.userSelector", [pos.PosId, options.UserType]);
                if (typeof mCase !== "undefined" && mCase.userExists(options.UserType, pos.PosId)) {
                    toasts.showToast({ 'type': 'warning', 'message': resourcesStore.get('UserAlreadyInList') });
                    _this.$input.val("");
                    _this.$input.data("posid", "");
                }
                else if (options.MultiSelect && pos && pos.PosId > 0) {
                    _this.addUser({ UserId: pos.PosId, UserDisplayName: pos.PosTitle, UserPicture: pos.PosPicture, Boxed: options.Boxed});
                    _this.$input.val("");
                    _this.$input.data("posid", "");
                }
                if (options.afterSelect)
                    options.afterSelect(pos, $input);
            }
        });
        $addUser.find(".expand-user-area").click(function () {
            var $curEl = $(this);
            if ($curEl.parents('li.hidden-user-select').length > 0 && typeof mCase !== "undefined")
                mCase.showUserArea($curEl);

            var $input = $(this).siblings("input");
            if ($input.data("posid")) {
                if (options.MultiSelect && pos && pos.PosId > 0) {
                    _this.addUser({ UserId: $input.data("posid"), UserNameForDisplay: $input.val(), UserPicture: "", Boxed: options.Boxed });
                }
            }
            $curEl.addClass('hidden');
            return false;
        });
        if (options.Users) {
            $.each(options.Users, function () {
                this.UserType = options.UserType;
                _this.addUser(this);
            });
        }
        _this.$ul.append($addUser);
        $div.append(this.$ul);

    }
    createUserSelector.prototype.setConfig = function (params) {
        this.$autocomplete[0].mautocomplete.setConfig(params);
    }
    createUserSelector.prototype.addUser = function (user) {
        user.UserType = this.options.UserType;
        var _this = this;
        var disabled = _this.options.disabled !== undefined ? _this.options.disabled : false;
        var $user = $(_this.userTemp({ "user": user, "disabled": disabled }));
        $user.find(".remuser").click(function () { return _this.removeUser(this); });
        var $li = _this.$ul.find(".adduser");
        var canAddUserToUl = _this.$ul.find('[data-userid="' + user.UserId + '"]').length == 0;
        if (canAddUserToUl) {
            if ($li.length > 0)
                $li.before($user);
            else
                _this.$ul.append($user);
        }
    }
    createUserSelector.prototype.getUsersIds = function () {
        var list;
        if (this.options.MultiSelect) {
            list = [];
            var $list = this.$div.find("li.userval");
            $list.each(function () { list.push($(this).data("userid")); });
        }
        else {
            list = this.$input.data("posid");
        }
        return list;
    }
    createUserSelector.prototype.setUser = function (user) {
        if (this.options.MultiSelect) {
            this.addUser(user);
        }
        else {
            this.$input.data("posid", user.UserId);
            this.$input.val(user.UserNameForDisplay);
        }
    }
    createUserSelector.prototype.disable = function () {
        this.$input.prop("disabled", true);
        if (this.options.MultiSelect) {

        }
    }
    createUserSelector.prototype.removeUser = function (ctrl) {
        var $li = $(ctrl).closest("li");
        this.$div.trigger("userRemoved.userSelector", [$li.data("userid"), this.options.UserType]);
        $li.remove();
        return false;
    }
    jQuery.fn.userSelector = function (options, par) {
        var result;
        this.each(function () {
            if (options === "users") {
                if (this.selector)
                    result = this.selector.getUsersIds();
            }
            else if (options === "disable") {
                if (this.selector)
                    result = this.selector.disable();
            }
            else if (options === "setuser") {
                if (this.selector)
                    result = this.selector.setUser(par);
            }
            else if (options === "setconfig") {
                if (this.selector)
                    result = this.selector.setConfig(par);
            }
            else {
                this.selector = new createUserSelector($(this), options);
                result = this.selector;
            }
        });
        return result;
    }
}(jQuery));
(function ($) {
    var createScopeSelector = function ($div, options) {
        var _this = this;
        _this.$div = $div;
        _this.$ul = $("<ul class='scopeselector'></ul>");

        options.placeholder = resourcesStore.get('AddNewScope');
        options.removeScope = resourcesStore.get('RemoveScope');

        if (options.selectPicture)
            _this.selectPicture = options.selectPicture;
        else
            _this.selectPicture = "";
        if (options.scopeSelectorPicture)
            _this.scopeSelectorPicture = options.scopeSelectorPicture;
        else
            _this.scopeSelectorPicture = "";

        if (!options.getItemsFunc)
            options.getItemsFunc = function (fieldConfig, keyword, pageSize) { console.log("No get data function") };

        _this.options = options;

        handlebarsHelper.getTemplates("/templates/mcommon.htmltemplate", "mcommon");
        //var addSelectTempl = handlebarsHelper.compileTemplate("scopeselector-addselect-template", "mcommon");
        _this.selectTemp = handlebarsHelper.compileTemplate("scopeselector-select-template", "mcommon");

        //var $addSelect = $(addSelectTempl(options));
        //this.$input = $addSelect.find("input.selectselect");

        //var dropDown = true;
        //var hideEmpty = true;
        //var config = {};

        //this.$autocomplete = this.$input.formAutocomplete({
        //    "getItemsFunc": options.getItemsFunc, "dropdown": dropDown, "fieldConfig": config,
        //    "hideEmpty": hideEmpty, afterSelect: function (pos, $input) {
        //        _this.$div.trigger("selectAdded.scopeSelector", [pos.PosId]);
        //        if (pos) {
        //            _this.addSelect({ "PosId": pos.PosId, "PosTitle": pos.PosTitle, "PosPicture": pos.PosPicture }, true);
        //            _this.$input.val("");
        //            _this.$input.data("posid", "");
        //        }
        //        if (options.afterSelect)
        //            options.afterSelect(pos, $input);
        //    }
        //});

        //$addSelect.find(".expand-select-area").click(function () {
        //    var $curEl = $(this);
        //    var $input = $(this).siblings("input");
        //    if ($input.data("posid")) {
        //        _this.addSelect({ SelectId: $input.data("posid"), SelectNameForDisplay: $input.val(), SelectPicture: "" });
        //    }
        //    $curEl.addClass('hidden');
        //    return false;
        //});
        if (options.selects.groupScopes) {
            $.each(options.selects.groupScopes, function () {
                _this.addSelect(this);
            });
        }
        //_this.$ul.append($addSelect);
        $div.append(this.$ul);
    }
    createScopeSelector.prototype.addSelect = function (select, fromAdd = false) {
        var _this = this;
        var $select_;
        if (fromAdd)
            $select_ = $(_this.selectTemp({ "selectName": select["PosTitle"], "selectId": select["PosId"], "selectPicture": _this.selectPicture, "removeScope": _this.options.removeScope, "noremoval":true}));
        else
            $select_ = $(_this.selectTemp({
                "selectName": select["scopeNameToDisplay"], "selectId": select["scopeId"], "selectPicture": _this.selectPicture, "removeScope": _this.options.removeScope, "noremoval": true}));
        $select_.find(".remselect").click(function () { return _this.removeSelect(this); });
        var $li = _this.$ul.find(".addselect");
        if ($li.length > 0)
            $li.before($select_);
        else
            _this.$ul.append($select_);
    }
    createScopeSelector.prototype.removeSelect = function (ctrl) {
        $('body>.tooltip').remove();
        var $li = $(ctrl).closest("li");
        this.$div.trigger("selectRemoved.scopeSelector", [$li.data("selectid")]);
        $li.remove();
        return false;
    }
    jQuery.fn.scopeSelector = function (options, par) {
        return new createScopeSelector($(this), options);
    }
}(jQuery));

(function ($) {
    var fixedHeader = function ($table, options) {
        var _this = this;
        var $scrollParent = $(options.scrollParent);
        $table.data("fixedHeader", true);
        $scrollParent.scroll(function () {
            var heigthPrev = options.divTopCorrection ? options.divTopCorrection : 0;
            var $head = $table.children("thead");
            if ($head.length == 0)
                return;
            var headHeight = $head.height();
            var offsetTop = $table.offsetTop(options.scrollParent);
			var $headTableDiv = $table.prev(".fixedheadertablediv");
			var scrollParentOffset = $(options.scrollParent).offset().top;
            if ($scrollParent.scrollTop() > offsetTop - scrollParentOffset - heigthPrev &&
                $scrollParent.scrollTop() < offsetTop + $table.height() - headHeight - scrollParentOffset) {
                if ($headTableDiv.length == 0) {
                    $headTableDiv = $("<div><table></table></div>");			
                    $headTableDiv.addClass("fixedheadertablediv").addClass("z-index-2-a");
                    var $headTable = $headTableDiv.find("table");
                    $headTable[0].className = $table[0].className;
                    $headTableDiv.attr("id", $table.attr("id") + "_fixedheader");
					$table.before($headTableDiv);
                    $headTableDiv.css("width", $table.parent().width());

                    var $headClone = $head.clone(true, true);
                    $headTable.append($headClone);
                    if (options.widthParent) {
                        var $resizeParent = $(options.widthParent);
                        if ($resizeParent.length > 0)
                            $resizeParent.on("panelresize", function () {
                                $headTableDiv.css("width", $table.parent().width());
                                $headTable.css("width", $table.outerWidth());
                                $headTable.css("max-width", $table.outerWidth());
								$headTableDiv.css("left", $table.offset().left + scrollLeft);
								$headTableDiv.css("top", $(options.scrollParent).offset().top + heigthPrev);
                                _this.setColumnsWidth($table, $headClone);
                            });
                    }

                    $head.addClass("tableheaderfixed");
                    $headTableDiv.css("top", $(options.scrollParent).offset().top + heigthPrev);
                    var scrollLeft = $headTableDiv.parent().scrollLeft();
                    $headTableDiv.css("left", $table.offset().left + scrollLeft);
                    $headTable.css("margin-left", -1 * scrollLeft);
                    $headTable.css("width", $table.outerWidth());
                    $headTable.css("max-width", $table.outerWidth());
                    _this.setColumnsWidth($table, $headClone);

                    $table.parent().on("scroll", function () {
                        var scrollLeft = $(this).scrollLeft();
                        $headClone.parent().css("margin-left", -1 * scrollLeft);
                    });
                }
                else
                    $headTableDiv.removeClass("hidden");
					
                $head.addClass("invisible");
            }
            else if ($headTableDiv.length > 0) {
                $headTableDiv.addClass("hidden");
                $head.removeClass("invisible");
            }
        });
    }
    fixedHeader.prototype.setColumnsWidth = function ($table, $headClone) {
        var $firstRow = '';
        if ($table.closest('.reportContainer').length > 0 || $table.closest('.report-content-container').length > 0 ) {
             $firstRow = $table.find("tbody>tr").first();
        }
        else {
             $firstRow = $table.find("tbody>tr.datarow").first();
        }
        
        if ($firstRow.length > 0) {
            var $tr = $headClone.find("tr").last();
            var $ths = $tr.find("th");
            $firstRow.children("td").each(function (idx) {
                $($ths[idx]).css("width", $(this).outerWidth());
            })
            if ($table.outerWidth() != $headClone.outerWidth()) {//correct width on first header cell
                var $firstTh = $($ths[0]);
                $firstTh.css("width", $firstTh.outerWidth() + $table.outerWidth() - $headClone.outerWidth())
            }
        }
    }
    var fixedColumns = function ($table, options) {
        var col;
        var $trArr = $table.find("tr");
        if ($trArr.length > 0) {
            var $tdArr = $($trArr.get(0)).children();
            var wsum = 0;
            for (col = 0; col < options.columns; col++) {
                var $td = $($tdArr.get(col));
                var w = $td.outerWidth();
                $.each($trArr, function () {
                    var $tdRow = $($(this).children().get(col));
                    $tdRow.css("left", wsum);
                    $tdRow.css("width", w);
                });
                wsum += w;
            }
            for (col = 0; col < options.columns; col++) {
                $.each($trArr, function () {
                    var $tdRow = $($(this).children().get(col));
                    $tdRow.addClass("fixedtablecolumn");
                });
            }
            var $tableDiv = $table.parent();
            var twidth = $tableDiv.outerWidth() - wsum;
            $tableDiv.css("width", twidth);
            $tableDiv.css("margin-left", wsum);
            var $scroll = $("#" + $tableDiv.attr("id") + "_scroll");
            if ($scroll.length > 0) {
                $scroll.find(".tableScrollInner").css("width", $table[0].scrollWidth);
                $scroll.css("width", twidth);
                $scroll.css("margin-left", wsum);
            }
        }
    }
    jQuery.fn.fixedHeader = function (options) {
        this.each(function () {
            this.fixHead = new fixedHeader($(this), options);
        });
    }
    jQuery.fn.fixedColumns = function (options) {
        this.each(function () {
            this.fixCols = new fixedColumns($(this), options);
        });
    }
    jQuery.fn.exportToExcel = function (options) {
        this.each(function () {
            var table = this;
            var func = function () {
                var wb = XLSX.utils.table_to_book(table, { sheet: options.sheetName ? options.sheetName : "Sheet" });
                return XLSX.writeFile(wb, options.fileName ? options.fileName : 'sheet.xlsx');
            }
            if (typeof XLSX === 'undefined') {
                $.getScript("/scripts/xlsx.full.min.js", function () {
                    func();
                });
            }
            else
                func();
        });
    }
}(jQuery));

var mDictionary = {
    addDictionaryItem: function (param, $input) {
        var template = mCase.compileTemplate("adddictionaryitem-template");
        var body = template(param.ParConfig);
        var parentId = "";
        var buttons = [{
            name: resourcesStore.get("Add"), id: "addposition", style: "btn-primary", action: function ($modal) {
                var dictId = param.ParConfig.DictId;
                var posValue = $modal.find("#newdictposvalue").val();
                if (posValue != "" && parentId != "0") {
                    preloader.addPreloader($(".adddictitem"), "adddictionaryitempreloader", true);
                    var dfd = $.Deferred();
                    var posDesc = "";
                    if ($modal.find("#newdictposdesc").length > 0)
                        posDesc = $modal.find("#newdictposdesc").val();
                    mCaseApi.addDictionaryItem(dictId, posValue, posDesc, parentId).then(function (response) {
                        $input.data("posid", response.DictPosId);
                        $input.val(response.DisplayTitle);
                        mCaseForm.removeFieldInfo($input, "validation");
                        var $ul = $(".autocompletefor_" + $input.attr("id"));
                        if ($ul.length > 0) {
                            $ul.append("<li><a href=\"#\" data-posid=\"" + response.DictPosId + "\" title=\"" + response.DisplayTitle + "\"><span>" + response.DisplayTitle + "</span></a></li>");
                        }
                        preloader.removePreloader($(".adddictitem"), "adddictionaryitempreloader");
                        $input.trigger("triggerchilds");
                        if (param.IsAsyncRuleField)
                            $input.trigger("change.rules");
                        dfd.resolve(true);
                    }, function (response) {
                        $modal.find(".additemerror").removeClass("hidden");
                        $modal.find(".additemerror").html(response.responseJSON);
                        preloader.removePreloader($(".adddictitem"), "adddictionaryitempreloader");
                        dfd.resolve(false);
                    });
                    return dfd;
                }
                else {
                    $modal.find(".additemerror").removeClass("hidden");
                    if (posValue == "")
                        $modal.find(".additemerror").html(resourcesStore.get("DictPosEmptyValue"));
                    else if (parentId == "0")
                        $modal.find(".additemerror").html(resourcesStore.get("DictPosParentItemEmpty"));
                    return false;
                }
            }
        }];
        var afterCreate = function ($modal) {
            $modal.find("#newdictposvalue").val($input.val());
            if (param.ParConfig.DictParentPpaId) {
                var $ctrl = $("#par" + param.ParConfig.DictParentPpaId + "_" + param.CaseId)
                if ($ctrl.val() != "") {
                    parentId = $ctrl.data("posid");
                }
                else {
                    $modal.find(".additemerror").removeClass("hidden");
                    $modal.find(".additemerror").html(resourcesStore.get("DictPosParentItemEmpty"));
                    $modal.find("#addposition").prop("disabled", true);
                    parentId = "0";
                }
            }
        };
        modalWindow.showModalWnd({
            title: resourcesStore.get("AddNewDictionaryItem"), message: body,
            id: "adddictionaryitem", "buttons": buttons, afterCreate: afterCreate
        });
    }
}
var dateConverter = {
    dateToString: function (val) {
        var r = val;
        if (val && val.length > 3) {
            var m = moment(val);
            if (m.toString() === "Invalid date")
                r = val;
            else {
                if (m.hour() == 0 && m.minute() == 0)
                    r = m.format(CultureInfo.DateFormat);
                else
                    r = m.format(CultureInfo.DateTimeFormat);
            }
        }
        return r;
    }
}
var moneyConverter = {
    moneyToString: function (val) {
        if (val === undefined || val === null)
            return "";
        var strVal = String(val);
        if (strVal === "")
            return strVal;
        var groupSep = CultureInfo.GroupSeparator;
        var decSep = CultureInfo.DecimalSeparator;

        if (decSep !== ".")
            strVal = strVal.replace(".", decSep);

        if (groupSep === '.')
            groupSep = ' ';
        var tab = strVal.split(decSep);
        if (tab.length > 0) {

            var d = tab[0].replace(new RegExp(groupSep, "g"), '');
            d = d.replace(/ /g, '');
            var r = '';
            var i;
            for (i = 0; i < d.length; i++) {
                if (i > 0 && i % 3 === 0) {
                    r = groupSep + r;
                }
                r = d.charAt(d.length - i - 1) + r;
            }

            if (tab[1]) {
                r = r + decSep + tab[1];
            }  
            else {
                r = r + decSep + '00';
            }
            strVal = r;


        }
        return strVal;

    }

}
var numericConverter = {
    numericToString: function (val, decNum) {
        if (val === undefined || val === null)
            return "";
        var strVal = String(val);
        if (strVal == "")
            return strVal;
        var groupSep = CultureInfo.GroupSeparator;
        var decSep = CultureInfo.DecimalSeparator;

        if (decSep != ".")
            strVal = strVal.replace(".", decSep);

        if (groupSep == '.')
            groupSep = ' ';
        var tab = strVal.split(decSep);
        if (tab.length > 0) {

            var d = tab[0].replace(new RegExp(groupSep, "g"), '');
            d = d.replace(/ /g, '');
            var r = '';
            var i;
            for (i = 0; i < d.length; i++) {
                if (i > 0 && i % 3 == 0) {
                    r = groupSep + r;
                }
                r = d.charAt(d.length - i - 1) + r;
            }

            if (decNum && decNum != "0") {
                if (tab[1])
                    r = r + decSep + tab[1] + strRepeat('0', decNum - tab[1].length);
                else
                    r = r + decSep + strRepeat('0', decNum);
            }
            else if (decNum && decNum == "0") {
                //do nothing
            }
            else if (tab[1]) {
                r = r + decSep + tab[1];
            }
            strVal = r;
        }
        return strVal;
    },
    stringToNumeric: function (val) {
        var decSep = CultureInfo.DecimalSeparator;
        var number;
        if (val) {
            if (decSep == ',') {
                number = val.replace(",", ".").replace(/\s/g, '').replaceCharCode(160);
            }
            else if (decSep == '.') {
                number = val.replace(",", "").replace(/\s/g, '').replaceCharCode(160);
            }

            if (numericConverter.isNumeric(number)) {
                var dblVar = Number(number);
                if (!isNaN(dblVar)) {
                    return dblVar;
                }
            }
        }
        return 0;
    },
    isNumeric: function (val) {
        var validChars = '0123456789.-';
        val = val.replace(",", ".").replace(/\s/g, '').replaceCharCode(160)
        for (var i = 0; i < val.length; i++) {
            if (validChars.indexOf(val.charAt(i)) == -1)
                return false;
        }
        return true;
    }
}

var booleanConverter = {
    booleanToString: function (val) {
        return val == "1" ? resourcesStore.get("Yes") : resourcesStore.get("No");
    }
}

var tours = {
    start: function (steps, tourname, waitFor) {
        $(function () {
            if (waitFor && typeof waitFor === "function") {
                waitFor(function () {
                    tours.startFun(steps, tourname);
                });
            }
            else {
                tours.startFun(steps, tourname);
            }
        });
    },
    startFun: function (steps, tourname) {
        try {
            var stepsArr = [];
            var index = 0;
            $.each(steps, function () {
                var step = {
                    index: index++,
                    selector: this[1],//jquery selector
                    description: this[2],
                    onBeforeStart: function () {
                        var a = this.index;
                        tours.setCurrentTourStep(this.index);
                    }
                };
                if (this[0] == "next")
                    step.event_type = this[0];
                else
                    step.event = this[0];
                stepsArr.push(step);
            });
            if (stepsArr.length > 0) {
                tours.repeatTour(stepsArr, tourname, 0);
                if (!tours.checkIfFinished(tourname))
                    tours.run(stepsArr, tourname);
            }
        }
        catch (e) {
            SystemLogError(e);
        }
    },
    run: function (stepsArr, tourname, step) {
        var enjoyhint_instance = new EnjoyHint({
            onStart: function () {
                tours.setCurrentTour(stepsArr, tourname);
            },
            onEnd: function () {
                tours.setFinished(tourname);
            },
            onSkip: function () {
                tours.setFinished(tourname);
            },
            nextText: "Dalej",
            skipText: "Przerwij"
        });
        enjoyhint_instance.set(stepsArr);
        if (!step)
            enjoyhint_instance.run();
        else
            enjoyhint_instance.reRunScript(step);
    },
    setCurrentTour: function (stepsArr, tourname) {
        mStorage.setItem("currenttour", JSON.stringify({ "tourname": tourname, "steps": stepsArr }));
    },
    setCurrentTourStep: function (step) {
        var tour = mStorage.getItem("currenttour");
        if (tour) {
            var tourObj = JSON.parse(tour);
            tourObj.step = step;
            mStorage.setItem("currenttour", JSON.stringify(tourObj));
        }
    },
    checkPending: function () {
        var tour = mStorage.getItem("currenttour");
        if (tour) {
            var tourObj = JSON.parse(tour);
            if (tourObj)
                tours.run(tourObj.steps, tourObj.tourname, tourObj.step + 1);
        }
    },
    checkIfFinished: function (tourname) {
        var toursInfo = mStorage.getItem("finishedtours");
        if (toursInfo) {
            var arr = JSON.parse(toursInfo);
            return arr.indexOf(tourname) >= 0;
        }
        else
            return false;
    },
    setFinished: function (tourname) {
        mStorage.removeItem("currenttour");
        var toursInfo = mStorage.getItem("finishedtours");
        var arr;
        if (toursInfo)
            arr = JSON.parse(toursInfo);
        else
            arr = [];
        if (arr.indexOf(tourname) < 0) {
            arr.push(tourname);
            mStorage.setItem("finishedtours", JSON.stringify(arr));
        }
    },
    repeatTour: function (stepsArr, tourname, count) {
        var $btn = $(".tour-repeat");
        if ($btn.length == 0 || count > 40) {
            setTimeout(function () { tours.repeatTour(stepsArr, tourname, count + 1); }, 500);
        }
        else {
            $btn.removeClass("hidden").click(function () {
                tours.run(stepsArr, tourname);
            });
        }
    }
}

var caseRegistryModal = {

    show: function (caseUrl, caseId, ppaId, paramCaseId) {

        var $div = $("<div class='overlay-container registry_editor'><div class='registry_editor_overlay'>" +
            "<div class='registry_editor_overlay_inner'>" +
            "<div class='registry_editor_overlay_div'>" +
            "<iframe height='100%' width='100%' src='" + caseUrl + "&advsearch=1'></iframe>'" +
            "</div></div></div></div>");

        $(document.body).append($div);
        if (caseId && ppaId && paramCaseId) {
            $('.overlay-container.registry_editor').on("remove", function () {
                mCaseApi.getReferenceCaseInfo(paramCaseId, ppaId, caseId).then(function (response) {
                    if (response.CaseId) {
                        mFormReferenceField.referenceTableSelectCaseByValues(response.CaseId, response.CaseTitle, ppaId, paramCaseId);
                    }
                })
            });
        }
    },
    showNew: function (prcId, ppaId, paramCaseId) {
        preloader.addPreloader($("#form"), "previewpreloader", true);
        mCaseApi.createNewCase(prcId)
            .then(function (caseId) {
                preloader.removePreloader($("#form"), "previewpreloader", true);
                var caseUrl = "Case.aspx?caseId=" + caseId
                caseRegistryModal.show(caseUrl, caseId, ppaId, paramCaseId);
            });
    },
    hide: function () {
        let amount = $('.overlay-container.registry_editor').length;
        if (amount == 0)
            return false;
        $('.overlay-container.registry_editor iframe').attr("src", "");
        $('.overlay-container.registry_editor').remove();
        return true;
    }
};

var registerModal = {
    show: function (url, afterClose) {
        var $div = $("<div class='overlay-container registry_editor'><div class='registry_editor_overlay'>" +
            "<div class='registry_editor_overlay_inner'>" +
            "<div class='registry_editor_overlay_div'>" +
            "<a id='closeModal' onclick='"+"registerModal.hide();registerModal.invokeAfterClose("+afterClose+");' style='position:absolute; font-size:14px;color:#333;width:67px;height:50px;padding:17px;margin-left:15px;' href='#'><span class='glyphicon glyphicon-arrow-left'/></a>" +
            "<iframe height='100%' width='100%' src='" + url + "'></iframe>'" +
            "</div></div></div></div>");
        $(document.body).append($div);
    },
    hide: function () {
        $('.overlay-container.registry_editor iframe').attr("src", "");
        $('.overlay-container.registry_editor').remove();
        preloader.removePreloaderDoc();
    },
    invokeAfterClose: function (afterClose) {
        if(afterClose)
            afterClose();
    }
    
}

var topMenuWorkerApi = {

    getTopMenuContent: function () {

        return mAjax.afxAjax({

            url: `../api/user/TopMenuContent`,
            type: 'GET',
            dataType: 'json'

        });

    },

    changeLanguage: function (_language, userId) {
        return mAjax.afxAjax({
            url: '../webservice/AMODWebService.asmx/ChangeLanguage',
            data: JSON.stringify({ language: _language, userId: userId?userId:0 }),
            type: 'POST',
            dataType: 'json',
            contentType: "application/json; charset=utf-8"
        });
    },

    checkLanguages: function (userId) {
        return mAjax.afxAjax({
            url: '../webservice/AMODWebService.asmx/CheckLanguages',
            data: JSON.stringify({ userId: userId ? userId : 0 }),
            type: 'POST',
            dataType: 'json',
            contentType: "application/json; charset=utf-8"
        });
    },

    changeStartPage: function (_startPage) {
        return mAjax.afxAjax({

            url: '../webservice/AMODWebService.asmx/ChangeStartPage',
            data: JSON.stringify({ startPage: _startPage }),
            type: 'POST',
            dataType: 'json',
            contentType: "application/json; charset=utf-8"
        });
    },

    logout: function () {
        return mAjax.afxAjax({

            url: '../webservice/AMODWebService.asmx/Logout',
            type: 'POST',
            dataType: 'json',
            contentType: "application/json; charset=utf-8"
        });
    },

    getLoginPage: function () {
        return $.ajax({
            url: '../webserviceanon/AMODWebServiceAnon.asmx/LoginPage',
            type: 'POST',
            dataType: 'json',
            contentType: "application/json; charset=utf-8"
        });
    },

    setLoginAs: function (userId) {
        return mAjax.afxAjax({
            url: '../api/user/loginas',
            data: JSON.stringify({ loginAs: userId }),
            type: 'PUT',
            contentType: "application/json; charset=utf-8"
        });
    },
    getUsersForLoginAs: function (keyword) {
        return mAjax.afxAjax({
            url: '../api/user?KeyWord=' + keyword + "&DontAllowAdmins=true&GetSystem=false&AllowExternal=true&NotAllowTemporary=true",
            type: 'get',
            contentType: "application/json; charset=utf-8"
        });
    },
    getUser: function (id) {
        return mAjax.afxAjax({
            url: '../api/user/' + id,
            type: 'get',
            contentType: "application/json; charset=utf-8"
        });
    },
    changeDesign: function (useOldDesign) {
        var uri = "../api/User/changedesign";
        if (useOldDesign == true)
            uri += "?newdesign=false";
        return mAjax.afxAjax({
            type: "put",
            cache: false,
            url: uri,
        });
    },
    loadVisualNotifications: function (skip, take) {
        var url = "../api/visualnotification/usernotifications/";
        if (!skip)
            skip = 0;
        if (!take)
            take = 0;
        if (take > 0)
            url += "?skip=" + skip + "&take=" + take;
        return mAjax.afxAjax({
            type: "get",
            cache: false,
            url: url,
        });
    },
    setVisualNotificationShown: function (notificationId) {
        var url = "../api/visualnotification/setshown/" + notificationId;
        return mAjax.afxAjax({
            type: "post",
            cache: false,
            url: url,
        });
    },
    setAllVisualNotificationShown: function () {
        var url = "../api/visualnotification/setAllshown/";
        return mAjax.afxAjax({
            type: "post",
            cache: false,
            url: url,
        });
    },
    setUseNewUX: function (useNewUX) {
        return mAjax.afxAjax({
            type: 'post',
            cache: false,
            url: '../api/user/SetUseNewUX',
            data: {useNewUX:useNewUX}
        });
    },
    buyLicence: function () {
        return mAjax.afxAjax({
            type: 'post',
            cache: false,
            url: '../api/user/buyLicence'
        });
    },
    manageLicence: function () {
        return mAjax.afxAjax({
            type: 'post',
            cache: false,
            url: '../api/user/manageLicence'
        });
    }
};
var licenceInfo = {
    showExpiredInfo: function () {
        $("body").one("preloaderdoc:removed", licenceInfo.showExpiredInfoFun);

    },
    showExpiredInfoFun: function () {
        handlebarsHelper.getTemplates("/templates/mcommon.htmltemplate", "mcommon");
        var template = handlebarsHelper.compileTemplate("licenceexpired-template", "mcommon");
        var body = template();
        modalWindow.showModalWnd({
            message: body,
            id: "licenceexpired",
            closeTitle: resourcesStore.get("Close"),
            afterClose: licenceInfo.licenceInfoClosed
        });
    },
    showDemoModeInfo: function (info, logoSrc) {
        $("body").one("preloaderdoc:removed", function () { licenceInfo.showDemoModeInfoFun(info, logoSrc); });
    },
    showDemoModeInfoFun: function (info, logoSrc) {
        handlebarsHelper.getTemplates("/templates/mcommon.htmltemplate", "mcommon");
        var template = handlebarsHelper.compileTemplate("licencedemomodeinfo-template", "mcommon");
        var par = { InfoText: info, LogoSrc: logoSrc };
        var body = template(par);
        modalWindow.showModalWnd({
            message: body,
            id: "demomodeinfo",
            closeTitle: resourcesStore.get("Close"),
            afterClose: licenceInfo.licenceInfoClosed
        });
    },
    licenceInfoClosed: function () {
        $("body").trigger("licences:closed");
    },
    executeAfter: function (toExecute) {
        if (licenceInfo.waitFor) {
            $("body").one("licences:closed", toExecute);
        }
        else {
            toExecute();
        }
    },
    buyLicence: function () {
        preloader.addPreloaderDoc();
        topMenuWorkerApi.buyLicence().then(function (response) {
            window.location.replace(response);
        });
    },
    manageLicence: function () {
        preloader.addPreloaderDoc();
        topMenuWorkerApi.manageLicence().then(function (response) {
            window.location.replace(response);
        });
    }
};
(function ($) {
    jQuery.fn.scrollToDiv = function (elem, speed, offset) {
        $(this).animate({
            scrollTop: $(this).scrollTop() - $(this).offset().top + $(elem).offset().top + offset
        }, speed == undefined ? 1000 : speed);
        return this;
    };
    jQuery.fn.offsetTop = function (selector) {
        var $elem = $(this);
        var top = $elem[0].offsetTop;
        while ($elem && $elem.length > 0 && !$elem.is(selector)) {
            $elem = $($elem[0].offsetParent);
            if ($elem && $elem.length > 0)
                top += $elem[0].offsetTop;
        }
        return top;
    }
}(jQuery));


/*--------slidercontent--------*/
(function ($) {

    var SliderContent = function (element, options) {

        var elem = $(element);
        var obj = this;

        var settings = $.extend({
            leftMinSize: 150,
            rightMinSize: 150,
            firstMoveStepSize: 20,
            moveStepSize: 1,
            leftPanelSelector: null,
            rightPanelSelector: null,
            sliderSelector: null,
            leftPanelSize: null,
            rightPanelSize: null,
            leftPanelHidden: false,
            rightPanelHidden: false
        }, options || {});
        settings.parentContainerId = elem.attr("id");
        settings.parentContainerSelector = "#" + settings.parentContainerId;

        // Public method - can be called from client code
        this.hideRightPanel = function () {
            $(settings.rightPanelSelector).addClass("hidden");
            $(settings.sliderSelector).addClass("hidden");
            $(settings.leftPanelSelector)
                .removeClass("hidden")
                .addClass("slidercontent-panel-full-width");
            currentState.leftPanelHidden = false;
            currentState.rightPanelHidden = true;
            saveState();
        };
        this.showRightPanel = function () {
            $(settings.rightPanelSelector).removeClass("hidden");
            $(settings.leftPanelSelector).removeClass("slidercontent-panel-full-width");
            if($(settings.leftPanelSelector).hasClass("hidden")) {
                $(settings.rightPanelSelector).addClass("slidercontent-panel-full-width");
            }
            else {
                $(settings.sliderSelector).removeClass("hidden");                
            }
            currentState.rightPanelHidden = false;
            saveState();
        };
        this.hideLeftPanel = function () {
            $(settings.leftPanelSelector).addClass("hidden");
            $(settings.sliderSelector).addClass("hidden");
            $(settings.rightPanelSelector)
                .removeClass("hidden")
                .addClass("slidercontent-panel-full-width");
            currentState.leftPanelHidden = true;
            currentState.rightPanelHidden = false;
            saveState();
        };
        this.showLeftPanel = function () {
            $(settings.leftPanelSelector).removeClass("hidden");
            $(settings.rightPanelSelector).removeClass("slidercontent-panel-full-width");
            if($(settings.rightPanelSelector).hasClass("hidden")) {
                $(settings.leftPanelSelector).addClass("slidercontent-panel-full-width");
            }
            else {
                $(settings.sliderSelector).removeClass("hidden");
            }
            currentState.leftPanelHidden = false;
            saveState();
        };
        this.increaseLeftPanel = function (increaseSize) {
            var containerWidth = $(settings.parentContainerSelector).width();
            var sliderWidth = $(settings.sliderSelector).outerWidth(true);
            var newLeftPanelSize = currentState.leftPanelSize + increaseSize;
            //if right is not to small
            if (containerWidth - sliderWidth - newLeftPanelSize < settings.rightMinSize)
                newLeftPanelSize = containerWidth - sliderWidth - settings.rightMinSize;
            //if left is not to small
            if (newLeftPanelSize < settings.leftMinSize)
                newLeftPanelSize = settings.leftMinSize;
            resizePanels(newLeftPanelSize, true);
        }
        this.leftPanelHidden = function () { return currentState.leftPanelHidden };
        this.rightPanelHidden = function () { return currentState.rightPanelHidden };

        // Private method - can only be called from within this object
        var initSlider = function () {
            var lastStep = -1;
            var sizeChange = -1;
            var startWidth = -1;
            var newRightPanelSize = 0;
            var newLeftPanelSize = -1;
            var startLeftPanelSize = 0;
            var startRightPanelSize = 0;
            var sliderWidth = $(settings.sliderSelector).outerWidth(true);
            var panelContainerWidth;
            $(settings.sliderSelector).draggable({
                axis: "x",
                start: function (event, ui) {
                    panelContainerWidth = $(settings.parentContainerSelector).width();
                    //remember init sizes of panels
                    startLeftPanelSize = $(settings.leftPanelSelector).outerWidth(true);
                    startRightPanelSize = $(settings.rightPanelSelector).outerWidth(true);
                    lastStep = ui.position.left;
                    sizeChange = 0;
                },
                drag: function (event, ui) {
                    //get slider possition change
                    sizeChange = ui.position.left;
                    //calculate new panels size
                    newLeftPanelSize = startLeftPanelSize + sizeChange;
                    newRightPanelSize = startRightPanelSize - sizeChange;
                    //check if panel is not to small
                    if (newLeftPanelSize < settings.leftMinSize)
                        newLeftPanelSize = settings.leftMinSize;
                    //if right to small, set to min value
                    else if (newRightPanelSize < settings.rightMinSize) {
                        newLeftPanelSize = panelContainerWidth - (sliderWidth + settings.rightMinSize);
                    }
                    //resize panels if change step is enough or if its first step
                    if (
                        (lastStep == 0 && Math.abs(sizeChange - lastStep) >= settings.firstMoveStepSize)
                        ||
                        (lastStep != 0 && Math.abs(sizeChange - lastStep) >= settings.moveStepSize)
                    ) {
                        resizePanels(newLeftPanelSize);
                        lastStep = sizeChange;
                    }
                    //reset possition of slider
                    ui.position.left = 0;
                },
                stop: function (event, ui) {
                    resizePanels(newLeftPanelSize);
                }
            });
        };

        var resizePanels = function (newLeftPanelSize, withAnimate) {
            var updateState = function () {
                currentState.leftPanelSize = $(settings.leftPanelSelector).outerWidth(true),
                    currentState.rightPanelSize = $(settings.rightPanelSelector).outerWidth(true),
                    saveState();
            };

            if (withAnimate)
                $(settings.leftPanelSelector).animate({ width: newLeftPanelSize }, 200, "linear", updateState);
            else {
                $(settings.leftPanelSelector).outerWidth(newLeftPanelSize, true);
                updateState();
            }
        };

        var initSizeFromLocalStorage = function () {
            if (settings.parentContainerId != null && settings.parentContainerId.length > 0) {
                loadState();

                if (currentState.leftPanelSize < settings.leftMinSize) {
                    currentState.leftPanelSize = settings.leftMinSize;
                }
                currentState.rightPanelSize = calculateOtherPanelSize(currentState.leftPanelSize);
                if (currentState.rightPanelSize < settings.rightPanelSize) {
                    currentState.rightPanelSize = settings.rightMinSize;
                    currentState.leftPanelSize = calculateOtherPanelSize(settings.rightMinSize);
                }
                $(settings.leftPanelSelector).outerWidth(currentState.leftPanelSize);
                $(settings.rightPanelSelector).outerWidth(currentState.rightPanelSize);
                if (currentState.leftPanelHidden && currentState.rightPanelHidden) {
                    $(settings.rightPanelSelector).addClass("hidden");
                    $(settings.leftPanelSelector).addClass("hidden");
                    $(settings.sliderSelector).addClass("hidden");
                }
                else if (currentState.leftPanelHidden) {
                    $(settings.leftPanelSelector).addClass("hidden");
                    $(settings.sliderSelector).addClass("hidden");
                    $(settings.rightPanelSelector).addClass("slidercontent-panel-full-width");
                }
                else if (currentState.rightPanelHidden) {
                    $(settings.rightPanelSelector).addClass("hidden");
                    $(settings.sliderSelector).addClass("hidden");
                    $(settings.leftPanelSelector).addClass("slidercontent-panel-full-width");
                }
                else {
                    $(settings.leftPanelSelector).removeClass("hidden");
                    $(settings.rightPanelSelector).removeClass("hidden");
                }
            }
        };

        //get local storege key
        var localStorageKey = function () {
            var pageName = location.pathname.split('/').slice(-1)[0];
            return pageName + "#" + settings.parentContainerId + "#" + window.innerWidth;
        };

        var saveState = function () {
            if (settings.parentContainerId != null && settings.parentContainerId.length > 0) {
                mStorage.setItem(localStorageKey(), JSON.stringify(currentState));
            }
        };
        var loadState = function () {
            if (settings.parentContainerId != null && settings.parentContainerId.length > 0) {
                var storageData = mStorage.getItem(localStorageKey());
                if (storageData != null) {
                    try {
                        currentState = JSON.parse(storageData);
                    }
                    catch (e) {
                    }
                }
            }
        };

        var calculateOtherPanelSize = function (firstPanelSize) {
            var panelContainerWidth = realWidth($(settings.parentContainerSelector));
            var sliderWidth = realOuterWidth($(settings.sliderSelector), true);
            return panelContainerWidth - sliderWidth - firstPanelSize;
        };

        var realWidth = function ($obj) {
            var clone = $obj.clone();
            clone.css("visibility", "hidden").removeClass("hidden");
            $('body').append(clone);
            var width = clone.width();
            clone.remove();
            return width;
        };

        var realOuterWidth = function ($obj, includeMargin) {
            var clone = $obj.clone();
            clone.css("visibility", "hidden").removeClass("hidden");
            $('body').append(clone);
            var width = includeMargin === true ? clone.outerWidth(true) : clone.outerWidth();
            clone.remove();
            return width;
        };

        //const
        var sliderWidth = 10;
        var containerWidth = realWidth($(settings.parentContainerSelector));

        // Private object
        var currentState = {
            leftPanelSize: null,
            rightPanelSize: null,
            leftPanelHidden: settings.leftPanelHidden != null 
                ? settings.leftPanelHidden
                : false,
            rightPanelHidden: settings.rightPanelHidden != null
                ? settings.rightPanelHidden
                : false
        };

        //panels sizes
        if (settings.leftPanelSize != null) {
            currentState.leftPanelSize = settings.leftPanelSize;
            currentState.rightPanelSize = containerWidth - 
                (currentState.leftPanelSize + sliderWidth);
        }
        else if(settings.rightPanelSize != null) {
            currentState.rightPanelSize = settings.rightPanelSize + sliderWidth;
            currentState.leftPanelSize = containerWidth - 
                (currentState.rightPanelSize + sliderWidth);
        }
        else {
            currentState.rightPanelSize = 400;
            currentState.leftPanelSize = containerWidth - 
                (currentState.rightPanelSize + sliderWidth);
        }
        
        //initialize
        $(settings.leftPanelSelector).addClass("slidercontent-panel-left");
        $(settings.rightPanelSelector).addClass("slidercontent-panel-right");
        $(settings.sliderSelector).addClass("slidercontent-slider");
        $(settings.parentContainerSelector).addClass("slidercontent-panel-container");

        if (!settings.skipLocalStorage)
            initSizeFromLocalStorage();
        initSlider();
    };


    $.fn.slidercontent = function (options) {
        var element = $(this);

        // Return early if this element already has a plugin instance
        if (element.data('slidercontent')) return element.data('slidercontent');

        // pass options to plugin constructor
        var slidercontent = new SliderContent(this, options);

        // Store plugin object in this element's data
        element.data('slidercontent', slidercontent);

        return slidercontent;
    };
})(jQuery);

(function ($) {
    $.fn.slimScrollDefault = function (options) {
        var settings = $.extend({
            color: '#444',
            alwaysVisible: true,
            height: "100%"
        }, options);

        this.each(function () {
            $(this).slimScroll(settings);
        });
        return this;
    }
})(jQuery);

// GUID/UUID generator
function generateUUID() { // Public Domain/MIT
    var d = new Date().getTime();
    if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
        d += performance.now(); //use high-precision timer if available
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
}


function getOuterHeight($element) {
    $element.css({
        "visibility": "hidden",
        "position": "absolute",
        "top": 0,
        "left": 0
    });
    $("body").append($element);
    var outerHeight = $element.outerHeight(true);
    $element.css({
        "visibility": "",
        "position": "",
        "top": "",
        "left": ""
    });

    $element.detach();
    return outerHeight;
}
function isTouchDevice() {
    var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
    var mq = function (query) {
        return window.matchMedia(query).matches;
    }

    if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
        return true;
    }

    // include the 'heartz' as a way to have a non matching MQ to help terminate the join
    // https://git.io/vznFH
    var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
    return mq(query);
}
function isSafari() {
    var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    return isSafari;
}
var operatingSystemDetector = {
    getOperatingSystem: function () {
        let userAgent = window.navigator.userAgent.toLowerCase(),
            macosPlatforms = /(macintosh|macintel|macppc|mac68k|macos)/i,
            windowsPlatforms = /(win32|win64|windows|wince)/i,
            iosPlatforms = /(iphone|ipad|ipod)/i,
            os = null;

        if (macosPlatforms.test(userAgent)) {
            os = "macos";
        } else if (iosPlatforms.test(userAgent)) {
            os = "ios";
        } else if (windowsPlatforms.test(userAgent)) {
            os = "windows";
        } else if (/android/.test(userAgent)) {
            os = "android";
        } else if (!os && /linux/.test(userAgent)) {
            os = "linux";
        }

        return os;
    }
};
(function ($) {
    $.extend({
        scrollWidth: function () {
            if (!jQuery.scrollWidthPx) {
                var $tmpDiv = $("<div style='visiblility:hidden;width: 400px;overflow-y:scroll'><div style='height:50px'>aaa</div></div>");
                $("body").append($tmpDiv);
                jQuery.scrollWidthPx = $tmpDiv[0].offsetWidth - $tmpDiv.children()[0].offsetWidth;
                $tmpDiv.remove();
            }
            return jQuery.scrollWidthPx;
        }
    });
    jQuery.fn.scrollOnHover = function () {
        return this.each(function () {
            var $th = $(this);
            $th.css("overflow", "hidden");
            $th.css("padding-right", $.scrollWidth()+ "px");
            $th.on({
                mouseenter: function () {
                    if ($th.children().length > 0 && $th.children()[0].scrollHeight > $th.height()) {
                        $th.css("overflow", "auto");
                        $th.css("padding-right", "0px");
                    }
                },
                mouseleave: function () {
                    $th.css("overflow", "hidden");
                    $th.css("padding-right", $.scrollWidth() +"px");
                }
            });
        });
    }
}(jQuery));
(function ($) {
    jQuery.fn.amoditdatetimepicker = function (options, timePicker) {
        var locale = CultureInfo.Locale;
        if (locale === "ua")
            locale = "uk"; //moment.js uses 'uk' instead of 'ua' for Ukraine

        var stdoptions = {
            locale: locale,
            showClear: true,
            showClose: true,
            showTodayButton: true,
            allowInputToggle: true,
            useCurrent: false,
            format: timePicker ? CultureInfo.TimeFormat : CultureInfo.DateFormat
        };
        if (options)
            $.extend(stdoptions, options);
        return this.each(function () {
            $(this).datetimepicker(stdoptions);
        });
    }
}(jQuery));


var scriptLoader = {
    addScript: function (content, css) {
        var head = document.getElementsByTagName('head')[0];
        if (css === true) {
            var link = document.createElement('link');
            link.rel = 'stylesheet';
            link.type = 'text/css';
            link.href = content;
            head.appendChild(link);
        }
        else {
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = content;
            head.appendChild(script);
        }
    },
    addScripts: function (scriptsTable) {
        var head = document.getElementsByTagName('head')[0];
        var promises = [];
        $.each(scriptsTable, function (idx) {
            var elem = scriptsTable[idx];
            if (elem.startsWith("/"))
                elem = RelativeUrl + elem;
            var ext = elem.split(".");
            var $def = $.Deferred();
            promises.push($def);
            if (ext[ext.length - 1] === "js") {
                var script = document.createElement('script');
                head.appendChild(script);
                script.onload = function () {
                    $def.resolve(true);
                };
                script.type = 'text/javascript';
                script.src = elem;
            }
            else {
                var link = document.createElement('link');
                head.appendChild(link);
                link.onload = function () {
                    $def.resolve(true);
                };
                link.rel = 'stylesheet';
                link.type = 'text/css';
                link.href = elem;
            }
        });
        return $.when.apply($, promises);
    },
    addCssStyle: function (style) {
        var styleElem = document.createElement('style');
        styleElem.type = 'text/css';
        styleElem.innerHTML = style;
        document.getElementsByTagName('head')[0].appendChild(styleElem);
    }
}
var progressCounter = {
    init: function (title) {
        var progressHub = $.connection.progressHub;
        progressHub.client.updateProgress = progressCounter.updateProgress;
        progressHub.client.startProgress = progressCounter.startProgress;
        progressHub.client.stopProgress = progressCounter.stopProgress;
        progressHub.connection.start().done(function () {
            progressHub.server.registerConnection(CurrentOrganization, CurrentRealUserId);
            window.progressHub = progressHub;
        });
        progressCounter.progressTitle = title;
    },
    updateProgress: function (finished, total, text) {
        if ($(".import-progress").length == 0)
            progressCounter.showProgressBar(progressCounter.progressTitle);
        var percentage = Math.round(finished / total * 100);
        $(".import-progress .progress-bar").attr("aria-valuenow", percentage);
        $(".import-progress .progress-bar").css({ width: percentage + "%" });
        $(".import-progress #current-progress").html(finished + "/" + total);
    },
    startProgress: function (title, count) {
        progressCounter.progressTitle = title;
        if ($(".import-progress").length == 0)
            progressCounter.showProgressBar(progressCounter.progressTitle);
        if (count > 0)
            progressCounter.updateProgress(0, count);
    },
    stopProgress: function () {
            $(".import-progress").remove();
    },
    showProgressBar: function (title) {
        handlebarsHelper.configHandlebars();
        handlebarsHelper.getTemplates("/templates/mcommon.htmltemplate", "mcommon");
        var template = handlebarsHelper.compileTemplate("signalr-import-progress", "mcommon");
        if ($(".preloaderwrapper").length > 0)
            $(".preloaderwrapper").append(template());
        else
            $("body").append(template());
        if (title)
            $(".import-progress .progress-title").html(title);
    }

};

var jsTreeUtility = {
    search: function (str, treeSelector) {
        var _self = this;

        var $tree = $(treeSelector);

        if (str) {
            var $jstree = $tree.jstree(true);
            var js = $jstree.get_json();
            $tree.on("close_all.jstree", function () {
                $tree.find(".jstree-node").removeClass("jstree-nothidden").removeClass("hidden");
                $tree.find(".jstree-anchor").removeClass("jstree-search");
                var re = new RegExp(str, "i");
                _self.searchNode($jstree, $tree, js[0], str, re);
                $tree.find(".jstree-node").not(".jstree-nothidden").addClass("hidden");
            });
            $jstree.close_all();
        }
        else {
            $tree.find(".jstree-node").removeClass("hidden");
            $tree.find(".jstree-anchor").removeClass("jstree-search");
        }
    },
    searchNode: function ($jstree, $tree, js, str, re) {

        var _self = this;

        if (js.text.search(re) >= 0 || js.data && js.data.search && js.data.search.search(re) >= 0) {
            var node = $jstree.get_node(js.id);
            $.each(node.parents.reverse(), function () {
                if (this != "#") {
                    var par = $jstree.get_node(this);
                    $tree.find("#" + par.id + ".jstree-node").addClass("jstree-nothidden").removeClass("hidden");
                    $jstree.open_node(par);
                }
            });
            $jstree.show_node(node);
            $tree.find("#" + js.id + ".jstree-node").addClass("jstree-nothidden");
            $tree.find("#" + js.id + ".jstree-node .jstree-anchor").addClass("jstree-search");
        }
        $.each(js.children, function () {
            _self.searchNode($jstree, $tree, this, str, re);
        });
    }
}

var localCache = {
    setWithExpiry: function (key, value, ttl) {
        var now = new Date()

        var item = {
            value: value,
            expiry: now.getTime() + ttl * 1000,//ttl is s
        }
        localStorage.setItem(key, JSON.stringify(item))
    },
    getWithExpiry: function (key, def) {
        var itemStr = localStorage.getItem(key)
        if (!itemStr) {
            return (typeof def !== 'undefined' ? def : null);
        }
        var item = JSON.parse(itemStr)
        var now = new Date()
        if (now.getTime() > item.expiry) {
            localStorage.removeItem(key)
            return (typeof def !== 'undefined' ? def : null);
        }
        else
            return item.value
    },
    clearKeys: function (key) {
        var arr = []; // Array to hold the keys
        // Iterate over localStorage and insert the keys that meet the condition into arr
        for (var i = 0; i < localStorage.length; i++) {
            if (localStorage.key(i).substring(0, key.length) == key) {
                arr.push(localStorage.key(i));
            }
        }

        // Iterate over arr and remove the items by key
        for (var i = 0; i < arr.length; i++) {
            localStorage.removeItem(arr[i]);
        }
    }
};

var CurrentCaseId = function () {
    var cId = window.location.search.match(/[?&]caseId=\d+[?&]?/);
    if (cId != null) {
        caseId = parseInt(cId[0].match(/\d+/)[0]);
    }
    return (typeof mCase == "undefined") ? caseId : parseInt(mCase.caseId);
};

(function ($) {
    var checkPasswordStrength = function ($input, minLen, minScore) {
        var _this = this;
        var passwordStrengthDesc = [resourcesStore.get('PassVeryWeak'), resourcesStore.get('PassWeak'), resourcesStore.get('PassBetter'), resourcesStore.get('PassAverage'), resourcesStore.get('PassStrong'), resourcesStore.get('PassVeryStrong')];
        $input.on("keypress", function () {
            var score = _this.passwordStrengthInt($input.val(), minLen);
            if (score < minScore) {
                $("#password").closest(".form-group").addClass("has-error");
                $("#passwordTooWeak").removeClass("hidden");
            }
            else {
                $("#password").closest(".form-group").removeClass("has-error");
                $("#passwordTooWeak").addClass("hidden");
            }

            $("#passwordStrength").html(passwordStrengthDesc[score]).removeClass("strength0 strength1 strength2 strength3 strength4 strength5").addClass("strength" + score);
        })
    }
    checkPasswordStrength.prototype.passwordStrengthInt = function (password, minLen) {
        var score = 0;
        var zeroPoints = minLen * 0.75;
        var betterLength = minLen * 0.9;
        var goodLength = minLen;
        var veryGoodLength = minLen * 1.2;
        if (password.length < zeroPoints)
            return 0;

        //if password bigger than 6 give 1 point
        if (password.length >= zeroPoints) score++;

        //if password has both lower and uppercase characters give 1 point	
        if ((password.match(/[a-z]/)) && (password.match(/[A-Z]/))) score++;

        //if password has at least one number give 1 point
        if (password.match(/\d+/)) score++;

        //if password has at least one special caracther give 1 point
        if (password.match(/.[!,@,#,$,%,^,&,*,?,_,~,-,(,)]/)) score++;

        //if password bigger than 12 give another 1 point
        if (password.length > betterLength) score++;
        if (password.length > goodLength) score++;
        if (password.length > veryGoodLength) score++;
        if (score > 5)
            score = 5;
        return score;
    }

    jQuery.fn.checkPasswordStrength = function (minLen, minScore) {
        return this.each(function () {
            var pass = new checkPasswordStrength($(this), minLen, minScore);
        });
    }

}(jQuery));
var urlHelper = {
    getUrlParameterValue: function (urlParameterName) {
        let searchParams = new URLSearchParams(window.location.search);
        if (searchParams && searchParams.has(urlParameterName)) {
            let parameterValue = searchParams.get(urlParameterName);
            return parameterValue;
        }
    },
};

var redirectHelper = {
    redirectTopWindow: function(url) {
        if (window.top.location.pathname.startsWith('/react')) {
            window.top.location.href = url;
        } else {
            window.location.href = url;
        }
    }
}

var reactMigrationHelper = {
    getReactWindow: function() {
        if (window.self !== window.top && window.top.location.pathname.startsWith('/react')) {
            return window.top;
        }
        
        return null;
    },

    isInReactWindow: function() {
        return !!reactMigrationHelper.getReactWindow()
    },


    isReactPath: function(path) {
        const reactWindow = reactMigrationHelper.getReactWindow();

        if (reactWindow) {
            return reactWindow.location.pathname.startsWith(path);
        } else {
            return false;
        }
    },

    navigateInReactWindow: function(url, forceReload) {
        const reactWindow = reactMigrationHelper.getReactWindow();

        if (reactWindow) {
            if (url.startsWith('/react') && !forceReload) {
                // Can be handled by react router ("navigate" is a custom method, see `useReactMigrationBridge`)
                reactWindow.navigate(url.replace(/^\/react/, ''))
            } else {
                // Browser refresh
                reactWindow.location.href = url
            }
        } else {
            throw new Error('No react window')
        }
    },

    navigateBasedOnContext: function(url) {
        if (this.isInReactWindow()) {
            this.navigateInReactWindow(url)
        } else {
            window.location.href = url
        }
    },

    reloadReactWindow: function() {
        const reactWindow = reactMigrationHelper.getReactWindow();

        if (reactWindow) {
            reactWindow.location.reload();
        } else {
            throw new Error('No react window')
        }
    },

    reloadBasedOnContext: function() {
        if (this.isInReactWindow()) {
            this.reloadReactWindow();
        } else {
            window.location.reload();
        }
    },

    getReactWindowRedirectUrl: function () {
        const reactWindow = this.getReactWindow();

        if (reactWindow) {
           return `/react` + reactWindow.getRedirectUrl();
        } else {
             throw new Error('No react window')
        }
    }
}

var highContrastManager = {
    applyHighContrast: function() {
        var AmoditTheme = localStorage.getItem("AmoditTheme");
        if (AmoditTheme) {
            try {
                var AmoditThemeObj = JSON.parse(AmoditTheme);
                if (AmoditThemeObj && AmoditThemeObj.state && AmoditThemeObj.state.theme) {
                    if (AmoditThemeObj.state.theme.isHighContrastMode) {
                        $("body").addClass("high-contrast");
                    }
                }
            } catch (e) {
            }
        }
    }
}